





























































































































































































































































































import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { Component, Prop, Watch,Mixins} from 'vue-property-decorator'
import { ClassData, EventData, GroupData, NoticeProps } from "@/scripts/datatypes"
import Notice from "@/components/Notice.vue"
import Common from '@/mixins/common'
import moment from 'moment-timezone'
//eslint-disable-next-line
const jaconv = require("jaconv")

interface StringDate{
  startTime: string;
  endTime: string;
  startDate: string;
  endDate: string;
}

type PostStatus = {
  [key in 'publish' | 'private' | 'draft' | 'trash']: string
}

type EventStatus = {
  [key in 'fixed' | 'pending']: string
}

type EventType = {
  [key in 'lesson' | 'task' | 'meeting' | 'interview' | 'others']: string
}

@Component({
  components: {
    Notice
  }
})

export default class ModalEditEvent extends Mixins(Common) {
  notice = {} as NoticeProps

  @Prop({type: Boolean, default: false}) private isLoading?: boolean
  @Prop({type: String, default: ''}) private message?: string
  @Prop({type: String, default: 'message.yes'}) private confirmText?: string
  @Prop({type: String, default: 'message.no'}) private cancelText?: string  
  @Prop({type: String, default: ''}) private errorMessage?: string

  //@Prop({type: String, default: ''}) private title?: string
  @Prop({type: Object, default: {}}) private theEventData?: EventData

  isActive = true

  title = ''

  groups: GroupData[] = []
  cls: ClassData[] = []

  innerEventData: EventData = {
    extendedProps: {}
  } as EventData

  strDate: StringDate = {
    startTime: '',
    startDate: '',
    endTime: '',
    endDate: ''
  }

  hasDeletedGroup = false
  hasDeletedClass = false

  $refs!: {
    teachers: InstanceType<typeof ValidationProvider>;
    students: InstanceType<typeof ValidationProvider>;
    hosts: InstanceType<typeof ValidationProvider>;
    guests: InstanceType<typeof ValidationProvider>;
    validationObserver: InstanceType<typeof ValidationObserver>;
  }


  get disabledEditEvent(){
    return this.period <= 0  || ! this.innerEventData.title || JSON.stringify(this.innerEventData) === JSON.stringify(this.theEventData)
  }

  get teacherUids() {
    const val = this.innerEventData.extendedProps.teacherUids
    if(this.$refs.teachers && this.eventType === 'lesson'){
      this.$refs.teachers.validate()
    }
    return val
  }

  get studentUids(){
    const val = this.innerEventData.extendedProps.studentUids
    if(this.$refs.students && this.eventType === 'lesson'){
      this.$refs.students.validate()
    }
    return val
  }

  getDateTime(date: string, time: string){
    const dT = moment(date).startOf('day');
    const hhMm = time.split(':')
    //console.log(dT.toDate())
    if(hhMm.length == 2){
      dT.add({h: parseInt(hhMm[0],10) , m: parseInt(hhMm[1],10)})
    }
    return dT.toDate()
  }

  postStatuses(): PostStatus | undefined{
    if(this.$te('event.postStatus')){
      return this.$t('event.postStatus') as unknown as PostStatus
    }
    return undefined
  }

  set postStatus(val: keyof PostStatus){
    this.innerEventData.extendedProps.postStatus = val
  }

  get postStatus(): keyof PostStatus {
    return this.innerEventData.extendedProps.postStatus
  }

  eventStatuses(): EventStatus | undefined{
    if(this.$te('event.status')){
      return this.$t('event.status') as unknown as EventStatus
    }
    return undefined;
  }

  set eventStatus(val: keyof EventStatus){
    this.innerEventData.extendedProps.status = val
  }

  get eventStatus(): keyof EventStatus {
    return this.innerEventData.extendedProps.status
  }

  eventTypes(): EventType | undefined{
    if(this.$te('event.type')){
      return this.$t('event.type') as unknown as EventType
    }
    return undefined;
  }

  get eventType(): keyof EventType{
    return this.innerEventData.extendedProps.type
  }

  set eventType(val: keyof EventType){
    if(this.eventType === 'lesson'){
      if(this.$refs.teachers){
        this.$refs.teachers.reset()
      }
      if(this.$refs.students){
        this.$refs.students.reset()
      }
    }else{
      if(this.$refs.hosts){
        this.$refs.hosts.reset()
      }
      if(this.$refs.guests){
        this.$refs.guests.reset()
      }
    }
    this.innerEventData.extendedProps.type = val
  }

  get groupId(): string {
    return this.innerEventData.extendedProps.groupId
  }

  set groupId(val: string){
    //console.log(this.innerEventData)
    const group = this.groups.find((group) => {
      if(group.groupId === val){
        return true
      }
      return false
    })

    if(group){
      this.innerEventData.extendedProps.groupId = val
      this.innerEventData.extendedProps.groupName = group.name
      this.innerEventData.extendedProps.memberMeta = group.memberMeta
      this.innerEventData.extendedProps.memberUids = group.memberUids || []
      this.innerEventData.extendedProps.hostUids = group.hostUids || []
      this.innerEventData.extendedProps.guestUids = group.guestUids || []
      this.innerEventData.extendedProps.groupRef = this.$getGroupsColRef().doc(val)

      this.hasDeletedGroup = false
    }else{
      this.innerEventData.extendedProps.groupId = ''
      this.innerEventData.extendedProps.groupName = ''
      this.innerEventData.extendedProps.memberMeta = {}
      this.innerEventData.extendedProps.memberUids = []
      this.innerEventData.extendedProps.hostUids = []
      this.innerEventData.extendedProps.guestUids = []
      delete this.innerEventData.extendedProps.groupRef
    }
    

  }

  get classId() {
    return this.innerEventData.extendedProps.classId
  }

  set classId(val){
    const cl = this.cls.find((cl) => {
      if(cl.classId === val){
        return true
      }
      return false
    })

    if(cl){
      this.innerEventData.extendedProps.classId = val
      this.innerEventData.extendedProps.className = cl.name
      this.innerEventData.extendedProps.memberMeta = cl.memberMeta
      this.innerEventData.extendedProps.memberUids = cl.memberUids || []
      this.innerEventData.extendedProps.teacherUids = cl.teacherUids || []
      this.innerEventData.extendedProps.studentUids = cl.studentUids || []
      this.innerEventData.extendedProps.classRef = this.$getClassesColRef().doc(val)
      this.hasDeletedClass = false
    }else{
      this.innerEventData.extendedProps.classId = ''
      this.innerEventData.extendedProps.className = ''
      this.innerEventData.extendedProps.memberMeta = {}
      this.innerEventData.extendedProps.memberUids = []
      this.innerEventData.extendedProps.teacherUids = []
      this.innerEventData.extendedProps.studentUids = []
      delete this.innerEventData.extendedProps.classRef
    }
    //console.log(this.innerEventData)

  }

  get startDate(): string {
    return this.strDate.startDate
  }

  set startDate(val: string){
    this.strDate.startDate = val
    const sD = val.replace(/\D/g,'')
    const eD = this.strDate.endDate.replace(/\D/g,'')
    if(sD > eD){
      this.strDate.endDate = val
    }
  }

  get endDate(): string {
    return this.strDate.endDate
  }

  set endDate(val: string){
    this.strDate.endDate = val
    const eD = val.replace(/\D/g,'')
    const sD = this.strDate.startDate.replace(/\D/g,'')
    if(sD > eD){
      this.strDate.startDate = val
    }
  }

  get startTime(): string {
    return this.strDate.startTime
  }

  set startTime(val: string){
    this.strDate.startTime = this.inputTimeFormat(val,this.startTime)
  }

  get endTime(): string {
    return this.strDate.endTime
  }

  set endTime(val: string) {
    this.strDate.endTime = this.inputTimeFormat(val,this.endTime)
  }

  get startDateTime(): Date{
    return this.getDateTime(this.strDate.startDate, this.strDate.startTime)
  }

  get endDateTime(): Date{
    return this.getDateTime(this.strDate.endDate, this.strDate.endTime)
  }

  get period(){
    const start = moment(this.startDateTime);
    const end = moment(this.endDateTime);
    if(start.isValid() && end.isValid()){
      this.innerEventData.start = this.startDateTime
      this.innerEventData.end = this.endDateTime
      return end.diff(start,'minutes')
    }
    return 0
  }

  get hostUids() {
    const val = this.innerEventData.extendedProps.hostUids
    if(this.$refs.hosts && this.eventType !== 'lesson'){
      this.$refs.hosts.validate()
    }
    return val
  }

  get guestUids(){
    const val = this.innerEventData.extendedProps.guestUids

    if(this.$refs.guests && this.eventType !== 'lesson'){
      this.$refs.guests.validate()
    }
    return val
  }

  get selectedClass() {
    return this.cls.find((cl)=>{return cl.classId === this.classId})
  }

  get selectedGroup(){
    return this.groups.find((group)=>{return group.groupId === this.groupId})
  }

  getDisplayName(uid: string){
    if(this.innerEventData.extendedProps.memberMeta[uid] && this.innerEventData.extendedProps.memberMeta[uid].displayName){
      return this.innerEventData.extendedProps.memberMeta[uid].displayName
    }
    return ''
  }

  toggleMember(method: string, theUid: string){

    if(! this.innerEventData.extendedProps.memberMeta[theUid]){
      return
    }

    const pos = method + 'Uids' as 'studentUids' | 'teacherUids' | 'hostUids' | 'guestUids'

    if(! Array.isArray(this.innerEventData.extendedProps[pos])){
      return
    }

    let tempArray = this.innerEventData.extendedProps[pos].slice()
    
    tempArray = tempArray.filter((uid) => {return ! (uid === theUid) })
  
    if(tempArray.length === this.innerEventData.extendedProps[pos].length){
      this.innerEventData.extendedProps[pos].push(theUid)
    }else{
      this.innerEventData.extendedProps[pos] = tempArray
    }

    if(['student','teacher'].includes(method)){
      this.innerEventData.extendedProps.memberUids = this.innerEventData.extendedProps.teacherUids.concat(this.innerEventData.extendedProps.studentUids)
    }

    if(['host','guest'].includes(method)){
      this.innerEventData.extendedProps.memberUids = this.innerEventData.extendedProps.teacherUids.concat(this.innerEventData.extendedProps.studentUids)
    }
  }

  inputTimeFormat(val: string, pre: string){
    val = jaconv.toHan(val)

    val = val.replace(/[^\d:]/,'')

    val = val.replace(/^:/,'')

    val = val.replace(/:{2}/,':')

    val = val.replace(/(:\d+):/,'$1')

    val = val.replace(/(\d{2})\d/,'$1')

    if(/^[3-9]$/.test(val)){
      val = '0' + val + ':'
    }else if(/^\d{2}$/.test(val) && pre.indexOf(':') === -1 ){
      val = val + ':'
    }else if( /^\d{2}:[6-9]$/.test(val)){
      val = val.replace(':',':0')
    }

    return val
  }

 
  @Watch('errorMessage')
  changeErrorMessage(newVal: string){
    //console.log(newVal)
    if(newVal != ''){
      /*
      this.observer.setErrors({
        title: this.$te(newVal) ? this.$t(newVal) as string : newVal
      })
      */

      this.notice = {
        message: newVal,
        duration: 0,
        deleteButton: true,
        type: {'is-danger': true},
        isShow: true
      }
    }
  }

  async created(){
    try{
      this.isActive = true

      if(this.theEventData){
        this.innerEventData = {...this.theEventData}
        this.innerEventData.extendedProps = {...this.theEventData.extendedProps}
        console.log(this.innerEventData)
        moment.tz.setDefault(this.theEventData.timeZone)
        this.title = this.theEventData.title || ''
        
        const start = moment(this.theEventData.start)
        const end = moment(this.theEventData.end)

        if(start.isValid()){
          this.strDate.startDate = start.format('YYYY-MM-DD')
          this.strDate.startTime = start.format('HH:mm')
        }else{
          const startOfHourAtNow = moment().startOf('hour')
          this.strDate.startDate = startOfHourAtNow.format('YYYY-MM-DD')
          this.strDate.startTime = startOfHourAtNow.format('HH:mm')
        }

        if(end.isValid()){
          this.strDate.endDate = end.format('YYYY-MM-DD')
          this.strDate.endTime = end.format('HH:mm')
        }else{
          const startOfHourAtNowAddHour = moment().add(1,'hours').startOf('hour')
          this.innerEventData.endDate = startOfHourAtNowAddHour.format('YYYY-MM-DD')
          this.innerEventData.endTime = startOfHourAtNowAddHour.format('HH:mm')
        }

        const classRef = await this.$getClassesColRef().where('deleted','==',false).where('disabled','==',false).get()
        this.cls = classRef.docs.map((doc) => {
          const row = doc.data()
          return {classId: doc.id,...row} as ClassData
        });

        const className = this.theEventData.extendedProps.className
        const classId = this.theEventData.extendedProps.classId

       

        /**
         * classが削除や変更のときの処理
         */

        if(className && classId){
          if(! this.cls.some((cl) => {return cl.classId === classId && cl.name === className})){
            this.hasDeletedClass = true
          }
        }
      
        const groupsRef = await this.$getGroupsColRef().where('deleted','==',false).where('disabled','==',false).get()
        this.groups = groupsRef.docs.map((doc) => {
          const row = doc.data()
          return {groupId: doc.id,...row} as GroupData
        });
  
        const groupName = this.theEventData.extendedProps.groupName
        const groupId = this.theEventData.extendedProps.groupId

        /**
         * groupが削除や変更のときの処理
         */

        if(groupName && groupId){
          if(! this.groups.some((group) => {return group.groupId === groupId && group.name === groupName})){
            this.hasDeletedGroup = true
          }
        }
      }
    }catch(error){
      console.log(error)
    }
  }

  async onConfirm(yes: boolean) {
    let result: EventData | false
  
    if(yes){
      
      if(! await this.$refs.validationObserver.validate()){
        return
      }

      result = {
        ...this.innerEventData
      }

      if(this.innerEventData.extendedProps.type === 'lesson'){
        result.extendedProps = {
          ...result.extendedProps,
          guestUids: [],
          hostUids: [],
          groupName: '',
          groupId: '',
        }
        delete result.extendedProps.groupRef
      }else {
        console.log(this.groupId)
        result.extendedProps = {
          ...result.extendedProps,
          teacherUids: [],
          studentUids: [],
          className: '',
          classId: '',
        }
        delete result.extendedProps.classRef
      }

      console.log(result)
    }else{
      result = false
    }
    this.$emit("onConfirm", result);
  }
}
